/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import classNames from "classnames";
import RightArrow from "PFIcons/right_arrow.svg";
import React from "react";

import css from "./expander.module.scss";

interface ExpanderProps {
  label: string;
  expanded: boolean;
  onExpand: () => void;
}

export const Expander = ({ label, expanded, onExpand }: ExpanderProps): JSX.Element => (
  <div className={css.item} onClick={onExpand}>
    <RightArrow height={11} viewBox="7 7 10 10" className={classNames({ [css.arrowExpanded]: expanded })} />
    <div className={css.label}>{label}</div>
  </div>
);
